import { date_dmy_func, loginUserDetails } from "../../../components/Common/CommonFunction";
import { numberWithCommas } from "../../Report_common_function";

export const columns = ["Entry Date", "Particulars", "In Amount", "Out Amount", "Balance"];

export const PageHedercolumns = ["Cashier", "Period"];


export const isBalanceRow = (name) => ["Opening Balance", "Closing Balance"].includes(name);

const fmt = (v) => numberWithCommas(Number(v || 0).toFixed(2));

// data = { Period, OpeningBalance, ClosingBalance, CashBookDetails: [...] }
export const Rows = (data) => {
    const details = data.CashBookDetails || [];
    let dayIn = 0;
    let dayOut = 0;

    return details.map((r, i) => {
        const isOpening = r.Particulars === "Opening Balance";
        const isClosing = r.Particulars === "Closing Balance";

        // every Opening row starts a new day block (opening amount sits in its In column)
        if (isOpening) { dayIn = 0; dayOut = 0; }
        dayIn += Number(r.InAmount || 0);
        dayOut += Number(r.OutAmount || 0);

        // the API sends the wrong date on Opening rows, use the next row's date
        const entryDate = isOpening ? (details[i + 1]?.EntryDate ?? r.EntryDate) : r.EntryDate;

        return [
            entryDate ? date_dmy_func(entryDate) : "",
            r.Particulars,
            fmt(isClosing ? dayIn : r.InAmount),
            fmt(isClosing ? dayOut : r.OutAmount),
            fmt(r.Balance),
        ];
    });
};

export const ReportHederRows = (data) => {
    const from = data.Period?.FromDate ?? data.FromDate;
    const to = data.Period?.ToDate ?? data.ToDate;
    return [[
        `${data.Period?.CashierName || "All"}`,
        `${date_dmy_func(from)}   to   ${date_dmy_func(to)}`,
    ]];
};